import React from 'react';
var AsyncResultProvider = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/extensible/async/result-provider" */'./result-provider').then(function (_ref) {
    var ResultProvider = _ref.ResultProvider;
    return {
      default: ResultProvider
    };
  });
});
export var AsyncProvider = function AsyncProvider(props) {
  return /*#__PURE__*/React.createElement(AsyncResultProvider, props, props.children);
};